import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, MapPin } from 'lucide-react';
import { Button } from './ui/button';
import { clinicInfo } from '../mock';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { label: 'Home', id: 'home' },
    { label: 'About', id: 'about' },
    { label: 'Services', id: 'services' },
    { label: 'Gallery', id: 'gallery' },
    { label: 'Testimonials', id: 'testimonials' },
    { label: 'Contact', id: 'contact' }
  ];

  return (
    <>
      {/* Top bar */}
      <div className="bg-emerald-700 text-white py-2 px-4">
        <div className="container mx-auto flex flex-wrap justify-between items-center text-sm">
          <div className="flex items-center gap-4 flex-wrap">
            <a href={`tel:${clinicInfo.phone}`} className="flex items-center gap-2 hover:text-emerald-200 transition-colors">
              <Phone size={14} />
              <span>{clinicInfo.phone}</span>
            </a>
            <a href={`tel:${clinicInfo.alternatePhone}`} className="flex items-center gap-2 hover:text-emerald-200 transition-colors">
              <Phone size={14} />
              <span>{clinicInfo.alternatePhone}</span>
            </a>
            <div className="hidden lg:flex items-center gap-2">
              <MapPin size={14} />
              <span>Balapur X Roads, Triveni Nagar Colony Phase 4, Hyderabad</span>
            </div>
          </div>
          <div className="hidden md:block text-xs">
            <span>Mon-Sat: {clinicInfo.hours.weekdays}</span>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className={`sticky top-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white'
      }`}>
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-4">
            {/* Logo */}
            <div className="flex items-center">
              <div>
                <h1 className="text-2xl md:text-3xl font-bold text-emerald-700">
                  {clinicInfo.name}
                </h1>
                <p className="text-xs md:text-sm text-gray-600 italic">{clinicInfo.tagline}</p>
              </div>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-8">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-gray-700 hover:text-emerald-600 font-medium transition-colors"
                >
                  {item.label}
                </button>
              ))}
              <Button 
                onClick={() => scrollToSection('appointment')}
                className="bg-emerald-600 hover:bg-emerald-700 text-white"
              >
                Book Appointment
              </Button>
            </nav>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden p-2"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t">
            <nav className="container mx-auto px-4 py-4 flex flex-col gap-4">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-left text-gray-700 hover:text-emerald-600 font-medium py-2 transition-colors"
                >
                  {item.label}
                </button>
              ))}
              <Button 
                onClick={() => scrollToSection('appointment')}
                className="bg-emerald-600 hover:bg-emerald-700 text-white w-full"
              >
                Book Appointment
              </Button>
            </nav>
          </div>
        )}
      </header>
    </>
  );
};
